<template>
  <b-card no-body
          class="mb-1 border-0"
  >
    <b-card-header header-tag="header"
                   class="p-0 border-0"
                   role="tab"
    >
      <b-button block
                v-b-toggle.accordion-3
                variant="primary"
      >
        <i class="fa fa-sitemap"/>
        UBICACIONES EMPRESA
      </b-button>
    </b-card-header>
    <b-card-body class="py-3 px-0">
      <b-row>
        <b-col sm="8">
          <b-form-group>
            <b-input-group>
              <b-form-input name="nombre"
                            type="text"
                            placeholder="Buscar..."
                            v-model="filtro"
                            class="text-uppercase"
                            @keypress.enter="filtrarUbicaciones"
              />
              <b-input-group-append>
                <b-button variant="primary"
                          @click.prevent="filtrarUbicaciones"
                >
                  <i class="fa fa-search fa-lg"/>
                  <span class="d-none d-md-inline-block">Buscar</span>
                </b-button>
                <b-button @click="limpiarFiltro">
                  <i class="fa fa-eraser fa-lg"/>
                  <span class="d-none d-md-inline-block"> Limpiar</span>
                </b-button>
              </b-input-group-append>
            </b-input-group>

          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <el-tree ref="tree"
                   :filter-node-method="filterNode"
                   :data="arbolUbicaciones"
                   draggable
                   node-key="id"
                   default-expand-all
                   :expand-on-click-node="false"
                   @node-drag-end="handleDragEnd"
                   @node-drag-start="handleDragstart"
          >
            <span class="custom-tree-node"
                  slot-scope="{ node, data }"
            >
              <span v-if="!node.data.children.length && node.data.get_ubicacion.get_nivel && node.data.get_ubicacion.get_nivel.nivel === 1"
                   class="ubicacionOculta"
                   v-b-tooltip.hover
                   title="Ubicación no visible en el inventario debido a que no tiene ubicación hija activa"
              >
                {{ node.data.label }}
              </span>
              <span v-else>{{ node.data.label }}</span>
              <span>
                <el-button type="text"
                           size="mini"
                           class="text-danger"
                           @click="() => eliminarUbicacionEmpresa({node, data})"
                >
                  <i class="fa fa-trash ml-2 mr-1"/> Eliminar
                </el-button>
              </span>
            </span>
          </el-tree>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>

import {mapActions, mapMutations, mapState} from 'vuex';

export default {
  name: 'ubicaciones-empresa',
  data() {
    return {
      filtro: '',
      ubicacion: '',
      newChild: {},
    };
  },
  methods: {
    filtrarUbicaciones() {
      this.$refs.tree.filter(this.filtro);
    },
    limpiarFiltro() {
      this.filtro = '';
      this.filtrarUbicaciones();
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    async nuevaUbicacionEmpresa() {
      this.selectedUbicacionEmpresa.id_ubicacion = this.id_ubicacion;
      this.selectedUbicacionEmpresa.id_parent = this.ubicacion === '' ? 0 : this.ubicacion;
      await this.crearUbicacionEmpresa(this.$route.params.id);
      await this.listarUbicacionesEmpresa(this.$route.params.id);
      await this.arbolUbicacionesEmpresa(this.$route.params.id);
    },
    append(data) {
      this.newChild = {
        id_ubicacion: data.id_ubicacion,
        label: data.label,
        duplicate: true,
        children: [],
      };
      if (!data.children) {
        this.$set(data, 'children', []);
      }
      data.children.push(this.newChild);
    },
    handleDragstart(node, event) {
      this.getSelectedArbolUbicacion(node.data);
    },
    async handleDragEnd(draggingNode, dropNode, dropType, ev) {
      this.selectedUbicacionEmpresa.id_parent = dropNode.data.id;
      await this.crearUbicacionEmpresa();

      await this.arbolUbicacionesEmpresa();
    },
    ...mapActions('ubicacion', [
      'crearUbicacionEmpresa',
      'listarUbicacionesEmpresa',
      'arbolUbicacionesEmpresa',
      'eliminarUbicacionEmpresa'
    ]),
    ...mapMutations('ubicacion', [
      'getSelectedArbolUbicacion'
    ]),
  },
  computed: {
    ...mapState('ubicacion', [
      'selectedUbicacionEmpresa',
      'ubicaciones',
      'id_ubicacion',
      'arbolUbicaciones'
    ]),
    verUbicaciones() {
      return this.arbolUbicaciones.length <= 0;
    },
    verBuscador() {
      if (this.filtro.id_nivel !== '') {
        return true;
      }
    }
  }
};
</script>

<style scoped>
.ubicacionOculta {
  color: red;
  font-weight: bold;
  text-decoration: underline;
}
</style>
